import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { PLATFORM_ID, Injectable, Inject } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { ShellDomainProvider } from '../utility/shell-domain.provider';
import { EcapCookieService } from '../cookie/ecap-cookie.service';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class TokenBootstraper {
    private isPlatformServer: boolean;

    constructor(
        private http: HttpClient,
        @Inject(PLATFORM_ID) platformId: string,
        private _cookieService: EcapCookieService) {
        this.isPlatformServer = isPlatformServer(platformId);
    }

    bootstrap(response) {
        if (this.isPlatformServer) {
            this.serveTokenBootstrap(response);
        } else {
            this.clientTokenBootstrap(response);
        }
    }

    public clientTokenBootstrap(response) {
        const expectedCookie = this._cookieService.getCookie("REFRESH_TOKEN");
        if (!expectedCookie) {
          let minutesToLive = 30*24*60; //dd*hh*mm==1 Month

          if(typeof ShellDomainProvider['api'].refreshTokenMinutesToLive === "number")
            minutesToLive = ShellDomainProvider['api'].refreshTokenMinutesToLive;

          this._cookieService.eraseAndSetCookie('REFRESH_TOKEN',response.body.refresh_token,minutesToLive);
        } else {
            // console.log('cookie was set, no need to rebootstrap');
        }
    }

    public serveTokenBootstrap(response) {

    }

    public getAnonymousToken(): Promise<any> {

        const body = new HttpParams().set('grant_type', 'client_credentials');
        const header = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        return firstValueFrom(this.http.post(ShellDomainProvider['api'].Token, body.toString(), { headers: header, withCredentials: true, observe: 'response' }));
    }
}
